import * as yup from 'yup';

import { accountsRequestSchema } from './accountsRequest.schema';

export const transactFlowSuitabilitySchema = accountsRequestSchema.pick([
  'suitabilityQuestionnaire',
  'investResponsibly',
]);

export type TransactFlowSuitabilitySchema = yup.InferType<typeof transactFlowSuitabilitySchema>;
